export const DEFAULT_REQUEST_INTERVAL_MS = 5000;

export const LS_WS_CONNECTION_KEY = 'WS_CONNECTION_URL';

export const DAYS_IN_YEAR_DEFAULT = 360;